<template lang="pug">
.detail
  van-nav-bar(title='审批流程详情' left-text='返回' left-arrow @click-left='onClickLeft' )
  .detailName
    h3 {{ routerParams.title }}
    van-tag(round :type='flowStatus[routerParams.status].type') {{ flowStatus[routerParams.status].text }}
  //- 非自定义数据 //- (v-if="floderData.length > 0")
  component(:is="businessForm" ref="businessForm" class="create" :list="floderData")
  .uploderList(v-if="floderData.length > 0")
    span 附件:
    .uploderDesc(v-for="item in floderData" @click='preview(item)')
      img(v-if="item.isFolder != 1" :src="className(item)")
      .fileName {{ item.fileName }}
  applicationFlow(ref="applicationFlow")
  userApprove(ref="userApprove" v-if="routerParams.viewParam == 'approve'")
</template>

<script>
import { mapState } from "vuex";
import flowService from "@/CommonDP/service/flow-service";
import { tableRowIcon, viewH5FileMethods } from "@/CommonDP/utils/docPublic";
import { mapComponentName } from "./component/flowUtils";
import applicationFlow from "./component/applicationFlow.vue";
import userApprove from "./component/userApprove.vue";
import allReview from "./modules/allReview.vue";
import blankFlowForm from "./modules/blankFlowForm.vue";
import check from "./modules/check.vue";
import common from "./modules/common.vue";
import leave from "./modules/leave.vue";
import qualityPlanCheck from "./modules/qualityPlanCheck.vue";
import tz from "./modules/tz.vue";
import formCreate from "../../settings/flow/components/formCreate.vue";
export default {
  components: { allReview, blankFlowForm, check, common, leave, qualityPlanCheck, tz, applicationFlow, userApprove, formCreate },
  data () {
    return {
      flowStatus: {
        1: { text: '已通过', type: 'success' },
        2: { text: '审批中', type: 'warning' },
        3: { text: '已撤回', type: 'danger' },
        0: { text: '已驳回', type: 'danger' }
      },
      businessForm: "", // 动态组件
      flowKey: '', // 流程类型
      formId: '', // 表单id,如果是自定义，通过id查表单
      isCustom: false, // 是否是自定义表单
      floderData: []// 附件
    };
  },
  computed: {
    ...mapState({
      prjInfo: state => state.projectMg.prjObj,
      floderObj: state => state.uploaderLocal.floderObj,
      enterpriseId: state => state.enterprise.enterpriseId,
      routerParams: state => state.projectMg.routerParams,
      userInfo: state => state.user.userInfo
    })
  },
  mounted () {
    this.getInit();
  },
  methods: {
    onClickLeft() {
      window.history.go(-1);
    },
    async getInit() {
      this.flowKey = this.routerParams.flowKey;
      console.log("当前流程数据：", this.routerParams);
      console.log(this.routerParams.flowKey);
      this.$refs.applicationFlow.setFlowStatus(this.routerParams.status);
      this.$refs.applicationFlow.queryCCUserIdList();
      this.formId = this.$route.query.formId;
      this.businessForm = mapComponentName(this.routerParams.flowKey, this.formId);
      await this.getBusinessForm();
      await this.getProcessDetail();
    },
    // 查询业务表单
    async getBusinessForm() {
      const res = await flowService.getBusinessForm(this.routerParams.flowInstanceId);
      if (this.isCustom) {
        this.floderData = res.data.fileInfoList || [];
        const formData = res.data.object[0]?.param;
        this.keys = Object.keys(res.data.object[0]?.param);
        this.elementParams = Object.entries(formData).map(([key, value]) => ({ key, value }));
        await this.$nextTick();
        if (this.routerParams.viewParam === "view") {
          this.fapi.coverValue(formData);
          this.fapi.disabled(true);
        } else {
          this.getFormElementPermissions(1);
        }
      } else {
        // revit查看流程时，fileInfoList里吧uploadType等于0的放到表单模型里
        if (this.routerParams.clientType === 2 && this.routerParams.startFlowMode === 1) {
          const fileInfoList = res.data.fileInfoList.filter((ele) => ele.uploadType !== 0);
          this.floderData = fileInfoList;
        } else {
          this.floderData = res.data.fileInfoList || [];
        }
        // this.$refs.businessForm.setFormData(res.data.object || {});
        this.$refs.businessForm.flowStatus = true;
        if (this.routerParams.viewParam === "approve") {
          this.$refs.userApprove.floderData = this.floderData;
        }
      }
    },
    async getProcessDetail() {
      const res = await flowService.queryInstanceNodes(this.routerParams.flowInstanceId);
      this.$refs.applicationFlow.setNodeList(res.data);
    },
    // 文件预览打开,文件变色
    async preview(row) {
      const params = {
        flowBusinessId: this.routerParams.flowBusinessId,
        fileId: row.fileId,
        fileName: row.fileName
      };
      const res = await flowService.readFlowFile(params);
      if (res.result === "0") row.isRead = 1;
      this.onLineView(row);
    },
    async onLineView(row) {
      const value = {
        fileId: row.fileId,
        versionId: row.versionIds,
        fileType: row.fileType,
        noNeedIssue: 'true',
        flowInstanceId: this.routerParams.flowInstanceId
      };
      viewH5FileMethods(row, value);
    },
    className(row) {
      return tableRowIcon(row);
    }
  }
};
</script>
<style lang="scss" scoped>
.detail{
  height: 100%;
  overflow: auto;
}
.detailName{
  height: 44px;
  display: flex;
  flex-direction: row;
  align-items: center;
  box-shadow: 0 2px 12px rgb(245, 241, 241);
  padding: 0 15px;
  h3 {
    font-size: 15px;
    line-height: 30px;
    font-weight: 700;
    padding-right: 10px;
    display: inline-block;
    white-space:nowrap;
    max-width: calc(100% - 70px);
    overflow-x: auto;
    scrollbar-width: none; /* firefox */
   -ms-overflow-style: none;
  }
  h3::-webkit-scrollbar {
    display: none;
  }
  .van-tag{
    margin-left: 10px;
    padding: 0 8px;
    line-height: 25px;
  }
}
.uploderList{
  padding: 0 15px;
  display: flex;
  flex-direction: column;
  .uploderDesc{
    display: flex;
    align-items: center;
    width: 100%;
    height: 35px;
    line-height: 35px;
  }
}
</style>
